import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { environment } from "../../environments/environment";
import { RESTAPIRequestResponseDetailsResult } from "../models/rest-api-request-response-details.model";

@Injectable({
    providedIn: 'root'
})

export class RestApiRequestResponseDetailsService {

    constructor(
        private http: HttpClient,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    ) { }

    getRestAPIRequestResponseDetails(clientName: string, apiName?: string, apiMethod?: string, claimKey?: string, requestedBy?: string, fromRequestedDate?: string, toRequestedDate?: string, status?: string, sortBy?: string, sortDir?: 'asc' | 'desc', skip = 0, count = 20
    ): Observable<RESTAPIRequestResponseDetailsResult> {

        let params = new HttpParams()
            .set('skip', skip.toString())
            .set('count', count.toString())
            .set('sortBy', sortBy ?? '')
            .set('sortDir', sortDir ?? '');

        if (apiName?.trim()) {
            params = params.set('apiName', apiName.trim());
        }
        if (apiMethod?.trim()) {
            params = params.set('apiMethod', apiMethod.trim());
        }
        if (claimKey?.trim()) {
            params = params.set('claimKey', claimKey.trim());
        }
        if (requestedBy?.trim()) {
            params = params.set('requestedBy', requestedBy.trim());
        }
        if (fromRequestedDate?.trim()) {
            params = params.set('fromRequestedDate', fromRequestedDate.trim());
        }
        if (toRequestedDate?.trim()) {
            params = params.set('toRequestedDate', toRequestedDate.trim());
        }
        if (status?.trim()) {
            params = params.set('status', status.trim());
        }

        const url = `${environment.apiUrl}RestAPIRequestResponseLog/logs/${clientName}`;

        return this.http.get<RESTAPIRequestResponseDetailsResult>(url, { headers: this.getHeaders(), params });
    }

    private getHeaders(): HttpHeaders {
        const token = this.oktaAuth.getAccessToken();

        if (!token) {
            throw new Error('No access token found');
        }

        return new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${token}`,
        });
    }
}